/** 登录形态枚举 */
export enum SwitchType {
  /** 手机 */
  mobile = 'mobile',
  /** 邮箱 */
  email = 'email',
  /** 二维码 */
  code = 'code',
}
/** 登录类型枚举 */
export enum PanelType {
  /** 登录 */
  login = 'login',
  /** 注册 */
  register = 'register',
  /** 忘记密码 */
  forgetPwd = 'forgetPwd',
}

export const ACTIONS = {
  DEFAULT: 'DEFAULT',
  FETCH_CODE: 'FETCH_CODE',
  FETCH_CODE_SUCCESS: 'FETCH_CODE_SUCCESS',
  FETCH_CODE_ERROR: 'FETCH_CODE_ERROR',
  SUBMIT_CLICK: 'SUBMIT_CLICK',
  SUBMIT_CLICK_ERROR: 'SUBMIT_CLICK_ERROR',
  ONBLUR_VALIDATE_ERROR: 'ONBLUR_VALIDATE_ERROR',
  CLEAR_CLICK: 'CLEAR_CLICK',
  AGREEMENT: 'AGREEMENT', // 签署协议
};
